module.exports = __webpack_public_path__ + "static/media/angryIcon.1a0ecbdb.png";